import { gql } from '@apollo/client/core';
import type {
  PartnerMemberAllowanceBalance,
  SubsidyAllowanceBalanceCreateInput,
  SubsidyAllowanceBalanceUpdateInput,
} from '@/models/PartnerMemberAllowanceBalances';
import { mutationExecute } from '@/Utils/graphqlAPI';

const UPDATE_SUBSIDY_ALLOWANCE_BALANCES = gql`
  mutation UpdateSubsidyAllowanceBalances(
    $partnerCodeName: String!
    $callerId: String!
    $updatedBalances: [SubsidyAllowanceBalanceUpdateInputType!]!
    $createdBalances: [SubsidyAllowanceBalanceCreateInputType!]!
    $removedBalanceIds: [Int!]!
  ) {
    updateSubsidyAllowanceBalances(
      partnerCodeName: $partnerCodeName
      callerId: $callerId
      updatedBalances: $updatedBalances
      createdBalances: $createdBalances
      removedBalanceIds: $removedBalanceIds
    ) {
      id
      amount
      overrideRenewAmount
      startBudgetAmount
      beginningDate
      suspensionDate
      preAuthorizationNumber
      subsidyAllowance {
        id
        allowanceName
        kind
        renewAmount
        isPartnerLevel
        budgetLimit
        isPreAuthorizationNumberRequired
      }
    }
  }
`;

export const updateSubsidyAllowanceBalances = async ({
  partnerCodeName,
  callerId,
  updatedBalances,
  createdBalances,
  removedBalanceIds,
}: {
  partnerCodeName: string;
  callerId: string;
  updatedBalances: SubsidyAllowanceBalanceUpdateInput[];
  createdBalances: SubsidyAllowanceBalanceCreateInput[];
  removedBalanceIds: number[];
}) => {
  const response = await mutationExecute<{ updateSubsidyAllowanceBalances: PartnerMemberAllowanceBalance[] }>({
    mutation: UPDATE_SUBSIDY_ALLOWANCE_BALANCES,
    variables: {
      partnerCodeName,
      callerId,
      updatedBalances,
      createdBalances,
      removedBalanceIds,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data?.updateSubsidyAllowanceBalances ?? null;
};
